var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1264_6696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33516 1.50505L2.39379 7.44642C0.98598 8.85423 0.98598 11.1367 2.39379 12.5445L8.33516 18.4859C9.74297 19.8937 12.0255 19.8937 13.4333 18.4859L19.3746 12.5445C20.7825 11.1367 20.7825 8.85423 19.3746 7.44642L13.4333 1.50505C12.0255 0.0972456 9.74297 0.0972449 8.33516 1.50505Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33516 1.50505L2.39379 7.44642C0.98598 8.85423 0.98598 11.1367 2.39379 12.5445L8.33516 18.4859C9.74297 19.8937 12.0255 19.8937 13.4333 18.4859L19.3746 12.5445C20.7825 11.1367 20.7825 8.85423 19.3746 7.44642L13.4333 1.50505C12.0255 0.0972456 9.74297 0.0972449 8.33516 1.50505Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61182 7.57403L7.61182 12.4261C7.61182 12.8937 7.99086 13.2727 8.45843 13.2727L13.3105 13.2727C13.7781 13.2727 14.1571 12.8937 14.1571 12.4261L14.1571 7.57403C14.1571 7.10646 13.7781 6.72742 13.3105 6.72742L8.45843 6.72742C7.99086 6.72742 7.61182 7.10646 7.61182 7.57403Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1264_6696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.884277)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.8081cf802879016b200419735b896e35.svg";
export { ForwardRef as ReactComponent };